import { FaBackward, FaForward } from 'react-icons/fa';
import ParallelList from './ParallelList';

const ItemsPopularity = ({ 
    popularItems, 
    unpopularItems, 
    fxMoveToPopular, 
    fxMoveToUnpopular,
    fxMoveAllToPopular, 
    fxMoveAllToUnpopular, 
    titlePopular, 
    titleUnpopular 
}) => {
    return (
        <div className="flex flex-wrap overflow-hidden p-2">
            <ParallelList items={popularItems} type="left" action={fxMoveToUnpopular} title={titlePopular} />
            <div className="w-1/5 flex items-center">
                <div className="flex flex-col items-center w-full">
                    <button
                        className="m-1 bg-gray-700 text-blue-400 cursor-pointer p-2 border border-gray-700 rounded hover:bg-gray-800"
                        onClick={fxMoveAllToUnpopular}
                        disabled={popularItems.length === 0}>
                            <FaForward />
                    </button>
                    <button
                        className="m-1 bg-gray-700 text-blue-400 cursor-pointer p-2 border border-gray-700 rounded hover:bg-gray-800"
                        onClick={fxMoveAllToPopular}
                        disabled={unpopularItems.length === 0}>
                            <FaBackward />
                    </button>
                </div>
            </div>
            <ParallelList items={unpopularItems} type="right" action={fxMoveToPopular} title={titleUnpopular} />
        </div>
    );
}

export default ItemsPopularity;